import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-branding-privateWhatsapp',
  templateUrl: './branding-editWhatsapp.modal.html'
})
export class PrivateWhatsappModal implements OnInit {
  whatsappNumber!: string;
  @Output('setWhatsappForBusiness') setWhatsappForBusiness: EventEmitter<any> = new EventEmitter();
  @Output('close') close: EventEmitter<any> = new EventEmitter();
  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {
    this.form = this.formBuilder.group(
      {
        whatsapp: new UntypedFormControl('', [Validators.required]),
      }
    );
  }
  
  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }
  
  back() {
    this.close.emit();
  }

  savePrivateWhatsapp() {
    this.setWhatsappForBusiness.emit(this.whatsappNumber);
  }
}
